import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkoutCart } from "../../store/thunks";
import { toast } from "react-toastify";

const CartCheckoutPage = () => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("");
    const cart = useSelector(state => state.cart);
    const user = useSelector(state => state.user.userData);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const subtotal = cart?.items?.reduce((acc, item) => acc + item.price * item.quantity, 0) || 0;
    const taxes = (subtotal * 0.13).toFixed(2);
    const shipping = cart?.items?.length > 0 ? 10.00 : 0.00;
    const total = (subtotal + parseFloat(taxes) + shipping).toFixed(2);

    const handleCheckout = async () => {
        setIsProcessing(true);
        try {
            if (paymentMethod === "Credit Card" && (!user.cards || user.cards.length === 0)) {
                toast.error("You need to add a credit card before proceeding to checkout.");
                navigate("/profile/edit");
                return;
            }

            const payload = {
                products: cart.items.map(item => ({
                    pid: item.productId,
                    quantity: item.quantity,
                })),
                paymentMethod: paymentMethod || user.payment
            };
            const response = await dispatch(checkoutCart(payload));
            const orderData = response.payload.order;
            if (orderData) {
                navigate(
                    "/order/confirmation",
                    { state: { message: "Payment Successfully", order: orderData } }
                );
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("An error occurred during checkout.");
            }
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="container mx-auto p-6 bg-white shadow-md rounded-lg">
            <h1 className="text-3xl font-semibold text-center mb-6">Checkout</h1>

            <div className="mb-6">
                <div className="flex justify-between text-lg font-medium">
                    <span>Subtotal:</span>
                    <span>${subtotal}</span>
                </div>
                <div className="flex justify-between text-lg font-medium">
                    <span>Taxes (13%):</span>
                    <span>${taxes}</span>
                </div>
                <div className="flex justify-between text-lg font-medium">
                    <span>Shipping:</span>
                    <span>${shipping}</span>
                </div>
                <div className="flex justify-between text-xl font-bold mt-4">
                    <span>Total:</span>
                    <span>${total}</span>
                </div>
            </div>
            <div className="mb-4">
                <label className="block text-gray-700">Payment Method:</label>
                <select
                    value={paymentMethod || user.payment}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                >
                    <option value="Balance">Balance</option>
                    <option value="Credit Card">
                        Credit Card
                        {user.cards && user.cards.length > 0 && (
                                <span>{` (${user.cards[0].cardNumber.slice(-4)})`}</span>
                        )}
                    </option>
                </select>
            </div>
            <button
                onClick={handleCheckout}
                className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-700 transition-all duration-300"
                disabled={isProcessing}
            >
                Complete Purchase
            </button>
        </div>
    );
};

export default CartCheckoutPage;
